// extracted by mini-css-extract-plugin
module.exports = {"dim":"admin-portal__ConfirmDialog__dim","dialog":"admin-portal__ConfirmDialog__dialog","buttonRow":"admin-portal__ConfirmDialog__buttonRow"};